module.exports = __webpack_public_path__ + "img/nishio-takumi@1920w.204babad.png";